import './index.less';
import React from 'react';
import { Message } from 'antd';
import { checkMobile } from '../../plugins/utils.js';

class LoginPassword extends React.Component {

  constructor() {
    super();
    this.state = {
      mobile: '',
      password: '',
    }
  }

  handleTextChange(key, value) {
    this.setState({
      [key]: value
    });
  }

  login() {
    const { login } = this.props;
    const { mobile, password } = this.state;
    if (!checkMobile(mobile)) {
      return;
    }
    if (!password.trim()) {
      Message.warn('请输入密码');
      return;
    }
    login(this.state);
  }

  render() {
    return (
      <div className='loginPassword'>
        <div className='loginPassword-phone'>
          <input type='text' placeholder='请输入手机号' onChange={e => this.handleTextChange('mobile', e.target.value)}/>
        </div>
        <div className='loginPassword-password'>
          <input type='password' placeholder='请输入密码' onChange={e => this.handleTextChange('password', e.target.value)}/>
        </div>
        <div className='loginPassword-btn' onClick={() => this.login()}>登录</div>
      </div>
    );
  }
}

export default LoginPassword;



// WEBPACK FOOTER //
// ./src/components/login/loginPassword.jsx